/** Isolated Analysis (RFP Discovery Scope) API helpers. */

export async function loadScopeAnalysis(jobId, { http, apiBase }) {
  const res = await http.get(`${apiBase}/rfp-jobs/${jobId}/analysis/scope`);
  return res.data;
}

export async function loadScopeAnalysisStatus(jobId, { http, apiBase }) {
  const res = await http.get(`${apiBase}/rfp-jobs/${jobId}/analysis/scope/status`);
  return res.data;
}

export async function runScopeAnalysis(jobId, { http, apiBase }) {
  const res = await http.post(`${apiBase}/rfp-jobs/${jobId}/analysis/scope/run`, null, {
    timeout: 900_000,
  });
  return res.data;
}

export function gridSourceLabel(source) {
  if (source === "scope_discovery_analysis") return "RFP Discovery Scope Analysis";
  if (source === "legacy_analysis") return "Analysis";
  return null;
}
